// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> passage
// Generated: 2026-10-22T16:38:38.156Z
// Counts: 1 design, 73 content, 35 slot group, 8 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Vancouver, WA Apartments for Rent</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Discover a convenient Vancouver location at Passage Apartments in Vancouver, WA. From shopping and dining to parks, recreation, and local attractions, our community puts a variety of destinations within easy reach.</span></p><p><span style=\"font-size: 10pt;\">Spend time outdoors at nearby LeRoy Haagen Memorial Community Park, or explore more of Vancouver at destinations like Wintler Community Park along the Columbia River. For shopping, dining, and entertainment, residents can explore Vancouver Mall, Columbia Square, and the many businesses located throughout the surrounding Vancouver area.</span></p><p><span style=\"font-size: 10pt;\">There's even more to discover throughout the city. Visit Fort Vancouver National Historic Site, explore aviation history at Pearson Air Museum, or head toward the Vancouver Waterfront for restaurants, trails, parks, and views along the Columbia River.</span></p><p><span style=\"font-size: 10pt;\">Passage's location also provides convenient access to major roadways, making it easy to reach destinations throughout Vancouver and the greater Portland-Vancouver metro area.</span></p><p><span style=\"font-size: 10pt;\">If you're searching for </span><a class=\"richtext-link\" href=\"/floor-plans\"><span style=\"font-size: 10pt;\"><u>apartments</u></span></a><span style=\"font-size: 10pt;\"> in Vancouver, WA, Passage puts shopping, dining, recreation, and everyday conveniences close to home. Explore the neighborhood, then browse our available two- and three-bedroom apartment floor plans to find your next space.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Vancouver, WA</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs. Complete the application below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Discover convenient features for everyday living at Passage Apartments in Vancouver, WA. From in-home features to community spaces for recreation and relaxation, Passage offers a variety of amenities alongside our </span><a class=\"richtext-link\" href=\"/floor-plans\"><span style=\"font-size: 10pt;\"><u>spacious two- and three-bedroom apartment floor plans</u></span></a><span style=\"font-size: 10pt;\">.</span></p><p><span style=\"font-size: 10pt;\">Spend time outdoors at the swimming pool and sundeck, or stay active in the on-site fitness center. The clubhouse provides additional shared space within the community, while the playground offers another outdoor amenity. Passage also provides available garages, high-speed internet access, on-site maintenance, and professional property management.</span></p><p><span style=\"font-size: 10pt;\">Inside our two- and three-bedroom apartments in Vancouver, WA, you'll find features designed for comfort and functionality. Apartment homes include fully equipped kitchens with convenient appliances, in-home washers and dryers, private patios or balconies, fireplaces, large closets, ceiling fans, individual climate control, and additional storage.</span></p><p><span style=\"font-size: 10pt;\">Whether you're searching for Vancouver, WA apartments with a pool, apartments with a fitness center, or a community offering convenient in-home features, Passage gives you a variety of amenities to explore.</span></p><p><span style=\"font-size: 10pt;\">Browse our two- and three-bedroom floor plans and current availability, or </span><a class=\"richtext-link\" href=\"/schedule-a-tour\"><span style=\"font-size: 10pt;\"><u>schedule a tour</u></span></a><span style=\"font-size: 10pt;\"> to experience the apartments and amenities at Passage in person.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Have questions about floor plans, pricing, availability, amenities, or the leasing process? Contact the team at Passage Apartments in Vancouver, WA, to learn more about our community and </span><a class=\"richtext-link\" href=\"/floor-plans\"><span style=\"font-size: 10pt;\"><u>available apartment homes</u></span></a><span style=\"font-size: 10pt;\">.</span></p><p><span style=\"font-size: 10pt;\">Passage offers spacious two- and three-bedroom apartments for rent in Vancouver, WA, with a variety of layouts and convenient in-home features. Explore current availability, compare floor plans, or reach out to our leasing team for more information about apartment features, community amenities, lease options, or the application process.</span></p><p><span style=\"font-size: 10pt;\">Interested in seeing Passage in person? Our team can also help you schedule a tour and provide additional information about available apartment homes and the surrounding Vancouver </span><a class=\"richtext-link\" href=\"/neighborhood\"><span style=\"font-size: 10pt;\"><u>neighborhood</u></span></a><span style=\"font-size: 10pt;\">.</span></p><p><span style=\"font-size: 10pt;\">Ready to learn more? Contact Passage today or schedule a tour to explore our apartments in Vancouver, WA.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Find the space you're looking for at Passage Apartments in Vancouver, WA. Our community offers a selection of spacious two- and three-bedroom floor plans with functional layouts and convenient features for everyday living.</span></p><p><span style=\"font-size: 10pt;\">Our thoughtfully designed apartments include an in-home washer and dryer, private patio or balcony, fireplace, large closets, additional storage, ceiling fans, individual climate control, and a fully equipped kitchen with a refrigerator, dishwasher, microwave, and other everyday essentials.</span></p><p><span style=\"font-size: 10pt;\">With multiple apartment floor plans to explore, you can compare layouts and available apartment homes to find the combination of space and features that meets your needs. Current pricing and availability are provided below, making it easy to see which apartments are available for your preferred move-in timeframe.</span></p><p><span style=\"font-size: 10pt;\">Beyond your apartment, Passage offers access to community </span><a class=\"richtext-link\" href=\"https://www.liveatpassage.com/amenities/\"><span style=\"font-size: 10pt;\"><u>amenities</u></span></a><span style=\"font-size: 10pt;\"> including a swimming pool, fitness center, clubhouse, sundeck, playground, and available garages.</span></p><p><span style=\"font-size: 10pt;\">If you're searching for two- or three-bedroom apartments for rent in Vancouver, WA, start your search at Passage. Browse our available floor plans below, take a </span><a class=\"richtext-link\" href=\"/virtual-tour\"><span style=\"font-size: 10pt;\"><u>virtual tour</u></span></a><span style=\"font-size: 10pt;\">, or schedule an in-person visit to explore our apartments and community.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Take a closer look at Passage with our gallery of Vancouver, WA apartment photos. Explore images of our apartment interiors, </span><a class=\"richtext-link\" href=\"/amenities\"><span style=\"font-size: 10pt;\"><u>community amenities</u></span></a><span style=\"font-size: 10pt;\">, outdoor spaces, and property grounds to get a better sense of what Passage has to offer before scheduling a tour.</span></p><p><span style=\"font-size: 10pt;\">Inside our </span><a class=\"richtext-link\" href=\"/floor-plans\"><span style=\"font-size: 10pt;\"><u>two- and three-bedroom apartments</u></span></a><span style=\"font-size: 10pt;\"> in Vancouver, WA, you'll find spacious layouts with features designed for convenient everyday living. Browse photos of apartment kitchens, living areas, bedrooms, bathrooms, and other interior spaces. Apartment homes feature fully equipped kitchens, in-home washers and dryers, private patios or balconies, fireplaces, large closets, ceiling fans, and additional storage.</span></p><p><span style=\"font-size: 10pt;\">Continue through the gallery to explore the community amenities at Passage. View photos of the swimming pool, fitness center, clubhouse, sundeck, playground, landscaped outdoor areas, and other shared spaces throughout the property.</span></p><p><span style=\"font-size: 10pt;\">Our apartment gallery makes it easy to explore Passage online and get a closer look at the features and amenities available throughout the community. After browsing the photos, explore our floor plans to compare layouts, pricing, features, and current availability.</span></p><p><span style=\"font-size: 10pt;\">If you're searching for apartments in Vancouver, WA, start your search with a closer look at Passage. Browse our property photos below, </span><a class=\"richtext-link\" href=\"/virtual-tour\"><span style=\"font-size: 10pt;\"><u>take a virtual tour</u></span></a><span style=\"font-size: 10pt;\">, or schedule an </span><a class=\"richtext-link\" href=\"/schedule-a-tour\"><span style=\"font-size: 10pt;\"><u>in-person visit</u></span></a><span style=\"font-size: 10pt;\"> to explore our Vancouver apartment community.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Find an available apartment at Passage with our interactive community map in Vancouver, WA. Explore the property online, view available apartment homes, and compare locations throughout the community to help narrow down your apartment search.</span></p><p><span style=\"font-size: 10pt;\">Passage offers spacious two- and three-bedroom apartments for rent in Vancouver, WA with thoughtfully designed layouts and convenient features. Apartment homes include fully equipped kitchens, in-home washers and dryers, private patios or balconies, fireplaces, large closets, ceiling fans, individual climate control, and additional storage.</span></p><p><span style=\"font-size: 10pt;\">Use the interactive apartment map below to explore current Vancouver, WA apartment availability, including specific apartment locations, floor plan details, pricing, and available move-in dates. The map provides another way to compare your options and find an available apartment with the layout and location you're looking for.</span></p><p><span style=\"font-size: 10pt;\">Throughout the community, Passage offers </span><a class=\"richtext-link\" href=\"/amenities\"><span style=\"font-size: 10pt;\"><u>amenities</u></span></a><span style=\"font-size: 10pt;\"> including a swimming pool, fitness center, clubhouse, sundeck, playground, high-speed internet access, and available garages.</span></p><p><span style=\"font-size: 10pt;\">If you're searching for </span><a class=\"richtext-link\" href=\"/floor-plans\"><span style=\"font-size: 10pt;\"><u>2- or 3-bedroom apartments in Vancouver, WA</u></span></a><span style=\"font-size: 10pt;\">, explore Passage using the interactive map below. Once you've found an available apartment you're interested in, review the floor plan details or </span><a class=\"richtext-link\" href=\"/schedule-a-tour\"><span style=\"font-size: 10pt;\"><u>schedule a tour</u></span></a><span style=\"font-size: 10pt;\"> to visit Passage in person.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Discover shopping, dining, parks, recreation, and local attractions near Passage Apartments in Vancouver, WA. Our community provides convenient access to destinations throughout Vancouver, including the Cascade Park area, Vancouver Mall, downtown Vancouver, and the Columbia River waterfront.</span></p><h3><span style=\"font-size: 10pt;\"><strong>Shopping &amp; Dining in Vancouver, WA</strong></span></h3><p><span style=\"font-size: 10pt;\">Living at Passage puts a variety of shopping and dining options within easy reach. Explore nearby retail destinations like Vancouver Mall and Columbia Square, along with grocery stores, restaurants, coffee shops, and everyday services throughout east Vancouver and the Cascade Park area.</span></p><p><span style=\"font-size: 10pt;\">The surrounding neighborhood offers a variety of dining options, whether you're looking for a quick meal, coffee, takeout, or a place to sit down and dine. Additional restaurants, retailers, and entertainment can be found throughout Vancouver and along nearby commercial corridors.</span></p><h3><span style=\"font-size: 10pt;\"><strong>Parks &amp; Outdoor Recreation</strong></span></h3><p><span style=\"font-size: 10pt;\">Explore outdoor spaces throughout Vancouver, including LeRoy Haagen Memorial Community Park, which offers trails, open spaces, and recreational amenities. Head toward the Columbia River to discover additional parks and waterfront destinations, including Wintler Community Park and the trails, green spaces, and riverfront areas found throughout Vancouver.</span></p><p><span style=\"font-size: 10pt;\">For even more opportunities to explore outdoors, Vancouver offers an extensive network of neighborhood parks, trails, and recreational areas within a short drive of Passage.</span></p><h3><span style=\"font-size: 10pt;\"><strong>Explore Vancouver's Local Attractions</strong></span></h3><p><span style=\"font-size: 10pt;\">There's plenty to discover beyond shopping and dining. Visit Fort Vancouver National Historic Site to learn more about the area's history, or explore aviation exhibits at Pearson Air Museum.</span></p><p><span style=\"font-size: 10pt;\">Downtown Vancouver and the Vancouver Waterfront offer additional restaurants, shops, public spaces, walking paths, and access to the Columbia River, providing even more destinations to explore throughout the city.</span></p><h3><span style=\"font-size: 10pt;\"><strong>Convenient Access Around Vancouver</strong></span></h3><p><span style=\"font-size: 10pt;\">Passage's East Vancouver location provides convenient access to I-205, helping connect the community with destinations throughout Vancouver and the greater Portland-Vancouver metro area. Nearby roadways also provide access to shopping, dining, recreation, employment centers, and everyday services throughout Clark County.</span></p><p><span style=\"font-size: 10pt;\">Whether you're searching for apartments in Vancouver, WA, apartments near Cascade Park, or apartments with convenient access to I-205, Passage puts a variety of Vancouver destinations within reach.</span></p><p><span style=\"font-size: 10pt;\">Explore the neighborhood around Passage, then </span><a class=\"richtext-link\" href=\"/floor-plans\"><span style=\"font-size: 10pt;\"><u>browse our available two- and three-bedroom floor plans</u></span></a><span style=\"font-size: 10pt;\"> to find your next apartment in Vancouver, WA.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Welcome to Passage Apartments in Vancouver, WA, where spacious floor plans, convenient apartment features, and community amenities come together in a well-connected Vancouver location. Choose from thoughtfully designed two- and three-bedroom apartments with the space and features you need for comfortable everyday living.</span></p><p><span style=\"font-size: 10pt;\">Inside our </span><a class=\"richtext-link\" href=\"https://www.liveatpassage.com/floor-plans/\"><span style=\"font-size: 10pt;\"><u>2 and 3-bedroom apartments in Vancouver, WA</u></span></a><span style=\"font-size: 10pt;\">, you'll find features designed with functionality in mind. Enjoy an in-home washer and dryer, private patio or balcony, fireplace, large closets, additional storage, ceiling fans, individual climate control, and a fully equipped kitchen with convenient appliances. With a variety of floor plans available, you can compare layouts, features, pricing, and availability to find an apartment that meets your needs.</span></p><p><span style=\"font-size: 10pt;\">Beyond your front door, Passage offers community </span><a class=\"richtext-link\" href=\"/amenities\"><span style=\"font-size: 10pt;\"><u>amenities</u></span></a><span style=\"font-size: 10pt;\"> with plenty of options for recreation and relaxation. Spend time by the swimming pool, stay active in the fitness center, or enjoy the clubhouse and sundeck. Additional community features include a playground, available garages, high-speed internet access, professional on-site management, and beautifully maintained landscaping.</span></p><p><span style=\"font-size: 10pt;\">Passage provides convenient access to shopping, dining, entertainment, recreation, and everyday essentials throughout the surrounding area. Nearby destinations include Vancouver Mall, Columbia Square, LeRoy Haagen Memorial Community Park, Fort Vancouver National Historic Site, and a variety of restaurants and services throughout Vancouver.</span></p><p><span style=\"font-size: 10pt;\">If you're searching for apartments for rent in Vancouver, WA, explore what Passage has to offer. Browse our available two- and three-bedroom floor plans, take a </span><a class=\"richtext-link\" href=\"/virtual-tour\"><span style=\"font-size: 10pt;\"><u>virtual tour</u></span></a><span style=\"font-size: 10pt;\">, view our community </span><a class=\"richtext-link\" href=\"/gallery\"><span style=\"font-size: 10pt;\"><u>photos</u></span></a><span style=\"font-size: 10pt;\">, or </span><a class=\"richtext-link\" href=\"/contact-us\"><span style=\"font-size: 10pt;\"><u>contact</u></span></a><span style=\"font-size: 10pt;\"> us to schedule an in-person tour to experience Passage Apartments for yourself.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Explore Passage from wherever you are with our virtual apartment tours in Vancouver, WA. Take a closer look at our community online and get a better sense of the apartment interiors, features, and spaces available at Passage before scheduling an in-person visit.</span></p><p><span style=\"font-size: 10pt;\">Passage offers spacious two- and three-bedroom apartments in Vancouver, WA, with thoughtfully designed layouts and convenient features for everyday living. </span><a class=\"richtext-link\" href=\"/floor-plans\"><span style=\"font-size: 10pt;\"><u>Apartment homes </u></span></a><span style=\"font-size: 10pt;\">include fully equipped kitchens, in-home washers and dryers, private patios or balconies, fireplaces, large closets, ceiling fans, and additional storage.</span></p><p><span style=\"font-size: 10pt;\">Our virtual tours provide another way to explore Passage during your apartment search. Move through featured spaces online, view apartment details, and get a closer look at the design and layout of our Vancouver community. You can also explore our floor plans to compare square footage, features, pricing, and current availability.</span></p><p><span style=\"font-size: 10pt;\">Beyond the apartment interiors, Passage offers </span><a class=\"richtext-link\" href=\"/amenities\"><span style=\"font-size: 10pt;\"><u>community amenities</u></span></a><span style=\"font-size: 10pt;\"> including a swimming pool, fitness center, clubhouse, sundeck, playground, and available garages.</span></p><p><span style=\"font-size: 10pt;\">If you're searching for 2- or 3-bedroom apartments in Vancouver, WA, start by exploring Passage online. Take a virtual tour today, then browse our available floor plans or </span><a class=\"richtext-link\" href=\"/contact-us\"><span style=\"font-size: 10pt;\"><u>contact us</u></span></a><span style=\"font-size: 10pt;\"> to schedule an in-person tour to see the community for yourself.</span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166803/01a0f8c9-221f-7498-be1f-ab85f7304521.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-01be-77de-9c1a-dcc12c55f442.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "The leasing office entrance with landscaping and signage."
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-855f-771d-a3dd-e88c55520a8b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool with lounge chairs and umbrellas in a residential complex."
      }
    }
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166807/019d20b7-9a43-765c-b6c6-a7d4ca42555c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious furnished living room at Passage with vaulted ceilings, a charcoal sofa, accent chairs, and a coffee table."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-01be-77de-9c1a-dcc12c55f442.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "The leasing office entrance with landscaping and signage."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019fa94a-a2e2-7717-8e7b-6b0a01212b15.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman smiling in a gym, next to weight plates."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166807/019d20b7-9a43-765c-b6c6-a7d4ca42555c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Furnished model living room with vaulted ceilings, a charcoal sofa, accent chairs, and a coffee table."
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166807/019f3955-ef93-70da-b474-18423b5bc242.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings with lush greenery and blue sky."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166807/019f3955-f624-748d-974c-d98544d15c8d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of an apartment complex exterior with buildings, parking lots, and surrounding trees."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019fa946-5dd8-74fc-be17-f91c756fb464.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two boys in a pool, one on a pineapple float and one on a donut float."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019fa94a-a43e-75b9-b770-ae834b95c72c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two women in athletic wear standing outside with trees and a fence behind them."
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-206d-702d-807f-6882ab8c29a1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of an apartment complex with surrounding trees and residential neighborhood."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166807/019f3955-ef93-70da-b474-18423b5bc242.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings with lush greenery and blue sky."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166807/019fa946-5dd8-74fc-be17-f91c756fb464.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two boys in a pool, one on a pineapple float and one on a donut float."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166807/019fa946-5b8b-723a-b8db-9462cfa01603.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Man relaxing on a couch with his dog on his lap."
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-83d5-723f-a696-a91a6be6c116.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-855f-771d-a3dd-e88c55520a8b.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-83ea-7618-95d2-1d0b66c2dfa0.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-f9e0-7088-bb48-82693c700d08.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-16c7-75bf-bd45-d1fed43a15be.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-e453-71ec-bc2a-2c83e93bedba.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-c8d5-7659-8e92-52a270a43bf1.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-1859-7404-8808-08defc776c44.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-16c7-75bf-bd45-d1fed43a15be.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lobby with coffee bar, seating area, and large window overlooking property."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166807/019fa946-5dd8-74fc-be17-f91c756fb464.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two boys in a pool, one on a pineapple float and one on a donut float."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-16c7-75bf-bd45-d1fed43a15be.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lobby with coffee bar, seating area, and large window overlooking property."
      }
    }
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-c8d5-7659-8e92-52a270a43bf1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings with balconies and trees."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166807/019fa946-5b8b-723a-b8db-9462cfa01603.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Man relaxing on a couch with his dog on his lap."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166807/019d20b7-9a43-765c-b6c6-a7d4ca42555c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room with vaulted ceilings, a charcoal sofa, accent chairs, and a coffee table."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 8,
    "hiddenIds": null,
    "orderedIds": [
      "custom_f2a18e9c-bd4c-44a7-abe4-e31ddb2564f0",
      "custom_4369b74e-8405-44e1-b578-3c099e4410c2",
      "custom_134b9212-3a8a-47cf-bf29-9b75e2557728",
      "custom_4137a116-368d-4d44-b05e-3a9d7ef3cbad",
      "custom_8ff2e9c7-fd25-41d0-9865-c8fa17e220d6",
      "custom_51cb5a80-2f33-44a6-8512-37f509ba9d49",
      "custom_2c9a1ac0-eecf-4f10-837b-9a739ec8d26c",
      "custom_1d9005dd-8ff2-4a10-8459-aa8265f1bc86",
      "custom_a1539711-c60b-4f9f-a1d0-634a6fe36f55",
      "custom_e09d5a45-0633-45a5-a55a-fa06fea7d185",
      "custom_421c9909-6ded-4257-9866-c4f97b7b06b5",
      "custom_eda87616-2032-46eb-8a3f-2f0532e924b4",
      "custom_e29ad3d3-58cb-49bb-b293-953ed1d1566b",
      "custom_ea3ff1cb-5775-4129-8e58-5f9e1886bc05",
      "custom_1cdd66ca-35d8-49fa-ad46-7c44ea3710e4",
      "custom_d7d617ac-6057-4842-b375-1b7b63253b3e",
      "custom_802752d9-06cb-46f6-a9e2-684e7f9ada8e",
      "custom_24015657-6ca9-44d0-bc8e-a67cb22840c4",
      "custom_e264d2e7-4f56-4d30-a31d-242c06a29abe",
      "custom_46308704-78c4-490e-9e26-ecdae32560e7",
      "custom_05e68a9f-ce19-4c50-a2f1-ca98f6e14a86",
      "custom_260a480b-2143-485e-95a8-9670b983a85e",
      "custom_184f4a2f-564a-44f9-9b97-335f62727c44",
      "custom_b17cffc9-bc9f-42ad-a436-575bb4a84399",
      "custom_50dcc2f0-08a7-4c93-8045-c0d93ed29c0f",
      "custom_aea3af6e-0678-4792-b1ad-d52a3317b81e",
      "custom_224e67bb-f3ab-4fa1-b8c8-47218acb728c",
      "custom_a234c0cb-a3e4-44bf-8075-946b8a0981af",
      "custom_3b3ffdf7-7cd4-4b84-aec3-335d289eb1be",
      "custom_8f7d2db5-b3d9-46ca-b9f3-0e5ea789fe80",
      "custom_953b81d7-7c4a-4a10-aa3b-1d6c2237666b",
      "custom_adf28263-9f90-4fa7-abf3-7a9fbfb3b6a0",
      "custom_ce621c5b-ba5e-437f-a207-ca7cd3986a0c",
      "custom_9c447006-6dc7-4f52-aec5-3cf679a3dd38",
      "custom_c79e6968-8549-401b-95cc-fac37bbef198",
      "custom_a582748d-28a0-4463-a975-6f1003423288",
      "custom_f170bba0-1586-45f2-a058-b2bdac2ef0a0",
      "custom_a3ae318a-995c-464a-a298-144a92ca87b2",
      "custom_2c2360c3-31ce-49b2-8e4a-b69f4d426881"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentItems": {
    "limit": null,
    "hiddenIds": [
      "custom_9c8b1ea5-675d-4a56-ab06-8aab5626ce8d"
    ],
    "orderedIds": [
      "custom_9480786a-5b59-4fd8-89b3-cb1096787c54",
      "custom_6db6e00f-68a2-4c08-a517-8174431e20cd",
      "custom_3e389bd3-15ac-4ff7-9c18-4f6e474cca5d",
      "custom_dfccfd74-46b5-4f70-936e-3349339b6de0",
      "custom_d0579ef4-8ef1-49a0-8881-e7d5b9d80013",
      "custom_ca05b096-2156-45ae-a680-c3cd1bfdd649",
      "custom_f943ab87-a228-4df2-86ec-5e304ba96241",
      "custom_e9ebab4a-45ae-4edd-80d2-a35e8ce44246",
      "custom_9c8b1ea5-675d-4a56-ab06-8aab5626ce8d",
      "custom_db464337-8c0b-4f14-868b-4d48ffddc80a",
      "custom_5ecc7b71-dd2f-43f2-a08c-fb9158aec4f2",
      "custom_76c9bde6-5728-4ef4-914c-db549ba31441",
      "custom_741e2c6c-d1b6-49a4-b2bb-3d8685be2896",
      "custom_9a6f48f0-d1ea-4ece-9608-1e85fb3c2ce0"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_ea3ff1cb-5775-4129-8e58-5f9e1886bc05",
      "custom_51cb5a80-2f33-44a6-8512-37f509ba9d49",
      "custom_e09d5a45-0633-45a5-a55a-fa06fea7d185",
      "custom_184f4a2f-564a-44f9-9b97-335f62727c44",
      "custom_adf28263-9f90-4fa7-abf3-7a9fbfb3b6a0",
      "custom_953b81d7-7c4a-4a10-aa3b-1d6c2237666b",
      "custom_05e68a9f-ce19-4c50-a2f1-ca98f6e14a86",
      "custom_802752d9-06cb-46f6-a9e2-684e7f9ada8e",
      "custom_a582748d-28a0-4463-a975-6f1003423288",
      "custom_19cbd077-817f-4180-b41e-313e2c1fe214",
      "custom_a3ae318a-995c-464a-a298-144a92ca87b2",
      "custom_2c2360c3-31ce-49b2-8e4a-b69f4d426881"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_1cdd66ca-35d8-49fa-ad46-7c44ea3710e4",
      "custom_4369b74e-8405-44e1-b578-3c099e4410c2",
      "custom_eda87616-2032-46eb-8a3f-2f0532e924b4",
      "custom_1d9005dd-8ff2-4a10-8459-aa8265f1bc86",
      "custom_f170bba0-1586-45f2-a058-b2bdac2ef0a0",
      "custom_a234c0cb-a3e4-44bf-8075-946b8a0981af",
      "custom_46308704-78c4-490e-9e26-ecdae32560e7",
      "custom_4137a116-368d-4d44-b05e-3a9d7ef3cbad",
      "custom_24015657-6ca9-44d0-bc8e-a67cb22840c4",
      "custom_46c8fcae-03f2-4c29-865d-40d5d46158a4",
      "custom_e264d2e7-4f56-4d30-a31d-242c06a29abe",
      "custom_7aaa0932-1a49-452a-97d6-7acd7fa1b6c8",
      "custom_d7d617ac-6057-4842-b375-1b7b63253b3e",
      "custom_e29ad3d3-58cb-49bb-b293-953ed1d1566b",
      "custom_8c7dbf32-9785-4dc0-8a92-b3b5d4179c79",
      "custom_134b9212-3a8a-47cf-bf29-9b75e2557728",
      "custom_260a480b-2143-485e-95a8-9670b983a85e",
      "custom_2c9a1ac0-eecf-4f10-837b-9a739ec8d26c",
      "custom_02df6b76-40d2-4a78-a175-276433790c74",
      "custom_aea3af6e-0678-4792-b1ad-d52a3317b81e",
      "custom_224e67bb-f3ab-4fa1-b8c8-47218acb728c",
      "custom_3b3ffdf7-7cd4-4b84-aec3-335d289eb1be",
      "custom_50dcc2f0-08a7-4c93-8045-c0d93ed29c0f",
      "custom_f2a18e9c-bd4c-44a7-abe4-e31ddb2564f0",
      "custom_b17cffc9-bc9f-42ad-a436-575bb4a84399",
      "custom_421c9909-6ded-4257-9866-c4f97b7b06b5",
      "custom_6337ac52-d12d-44b7-a669-61717c3d3df3",
      "custom_8ff2e9c7-fd25-41d0-9865-c8fa17e220d6",
      "custom_8f7d2db5-b3d9-46ca-b9f3-0e5ea789fe80",
      "custom_a3d34871-bf4f-4b53-96d4-d5def79d4722",
      "custom_ce621c5b-ba5e-437f-a207-ca7cd3986a0c",
      "custom_e110d288-7e54-47ee-89d6-feaf8b48797f",
      "custom_9c447006-6dc7-4f52-aec5-3cf679a3dd38",
      "custom_6c889cb9-e288-434c-86fe-b1071b83d137",
      "custom_c79e6968-8549-401b-95cc-fac37bbef198",
      "custom_a1539711-c60b-4f9f-a1d0-634a6fe36f55",
      "custom_e7f173c5-0364-4e90-8a1f-614418a0973b"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_9c447006-6dc7-4f52-aec5-3cf679a3dd38",
      "custom_aea3af6e-0678-4792-b1ad-d52a3317b81e",
      "custom_46308704-78c4-490e-9e26-ecdae32560e7",
      "custom_260a480b-2143-485e-95a8-9670b983a85e",
      "custom_24015657-6ca9-44d0-bc8e-a67cb22840c4",
      "custom_1cdd66ca-35d8-49fa-ad46-7c44ea3710e4",
      "custom_8f7d2db5-b3d9-46ca-b9f3-0e5ea789fe80",
      "custom_4369b74e-8405-44e1-b578-3c099e4410c2",
      "custom_2c9a1ac0-eecf-4f10-837b-9a739ec8d26c",
      "custom_b17cffc9-bc9f-42ad-a436-575bb4a84399",
      "custom_134b9212-3a8a-47cf-bf29-9b75e2557728",
      "custom_2c2360c3-31ce-49b2-8e4a-b69f4d426881",
      "custom_adf28263-9f90-4fa7-abf3-7a9fbfb3b6a0"
    ],
    "orderedIds": [
      "custom_f2a18e9c-bd4c-44a7-abe4-e31ddb2564f0",
      "custom_a1539711-c60b-4f9f-a1d0-634a6fe36f55",
      "custom_3b3ffdf7-7cd4-4b84-aec3-335d289eb1be",
      "custom_421c9909-6ded-4257-9866-c4f97b7b06b5",
      "custom_224e67bb-f3ab-4fa1-b8c8-47218acb728c",
      "custom_e264d2e7-4f56-4d30-a31d-242c06a29abe",
      "custom_f170bba0-1586-45f2-a058-b2bdac2ef0a0",
      "custom_4137a116-368d-4d44-b05e-3a9d7ef3cbad",
      "custom_d7d617ac-6057-4842-b375-1b7b63253b3e",
      "custom_8ff2e9c7-fd25-41d0-9865-c8fa17e220d6",
      "custom_e29ad3d3-58cb-49bb-b293-953ed1d1566b",
      "custom_a234c0cb-a3e4-44bf-8075-946b8a0981af",
      "custom_c79e6968-8549-401b-95cc-fac37bbef198",
      "custom_eda87616-2032-46eb-8a3f-2f0532e924b4",
      "custom_50dcc2f0-08a7-4c93-8045-c0d93ed29c0f",
      "custom_ce621c5b-ba5e-437f-a207-ca7cd3986a0c",
      "custom_1d9005dd-8ff2-4a10-8459-aa8265f1bc86",
      "custom_9c447006-6dc7-4f52-aec5-3cf679a3dd38",
      "custom_46308704-78c4-490e-9e26-ecdae32560e7",
      "custom_260a480b-2143-485e-95a8-9670b983a85e",
      "custom_aea3af6e-0678-4792-b1ad-d52a3317b81e",
      "custom_24015657-6ca9-44d0-bc8e-a67cb22840c4",
      "custom_1cdd66ca-35d8-49fa-ad46-7c44ea3710e4",
      "custom_8f7d2db5-b3d9-46ca-b9f3-0e5ea789fe80",
      "custom_4369b74e-8405-44e1-b578-3c099e4410c2",
      "custom_b17cffc9-bc9f-42ad-a436-575bb4a84399",
      "custom_2c9a1ac0-eecf-4f10-837b-9a739ec8d26c",
      "custom_134b9212-3a8a-47cf-bf29-9b75e2557728",
      "custom_e09d5a45-0633-45a5-a55a-fa06fea7d185",
      "custom_ea3ff1cb-5775-4129-8e58-5f9e1886bc05",
      "custom_51cb5a80-2f33-44a6-8512-37f509ba9d49",
      "custom_184f4a2f-564a-44f9-9b97-335f62727c44",
      "custom_a3ae318a-995c-464a-a298-144a92ca87b2",
      "custom_953b81d7-7c4a-4a10-aa3b-1d6c2237666b",
      "custom_05e68a9f-ce19-4c50-a2f1-ca98f6e14a86",
      "custom_a582748d-28a0-4463-a975-6f1003423288",
      "custom_802752d9-06cb-46f6-a9e2-684e7f9ada8e",
      "custom_adf28263-9f90-4fa7-abf3-7a9fbfb3b6a0",
      "custom_2c2360c3-31ce-49b2-8e4a-b69f4d426881"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.apartment_amenities": {
    "limit": 20,
    "hiddenIds": null,
    "orderedIds": [
      "custom_9480786a-5b59-4fd8-89b3-cb1096787c54",
      "custom_6db6e00f-68a2-4c08-a517-8174431e20cd",
      "custom_3e389bd3-15ac-4ff7-9c18-4f6e474cca5d",
      "custom_dfccfd74-46b5-4f70-936e-3349339b6de0",
      "custom_d0579ef4-8ef1-49a0-8881-e7d5b9d80013",
      "custom_ca05b096-2156-45ae-a680-c3cd1bfdd649",
      "custom_f943ab87-a228-4df2-86ec-5e304ba96241",
      "custom_e9ebab4a-45ae-4edd-80d2-a35e8ce44246",
      "custom_9c8b1ea5-675d-4a56-ab06-8aab5626ce8d",
      "custom_db464337-8c0b-4f14-868b-4d48ffddc80a",
      "custom_5ecc7b71-dd2f-43f2-a08c-fb9158aec4f2",
      "custom_76c9bde6-5728-4ef4-914c-db549ba31441",
      "custom_741e2c6c-d1b6-49a4-b2bb-3d8685be2896",
      "custom_9a6f48f0-d1ea-4ece-9608-1e85fb3c2ce0"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
